import React from 'react';

import * as Sentry from '@sentry/react';

import SomethingWentWrong from 'components/SomethingWentWrong/SomethingWentWrong';
import fetchErrorHandler, { isChunkLoadError } from 'utils/fetchErrorHandler/fetchErrorHandler';
import DataPersist, { DATA_PERSIST_KEY } from '../../utils/dataPersist/dataPersist';

const shouldFlushDataStorage = new DataPersist(DATA_PERSIST_KEY.SHOULD_FLUSH_STORAGES, 'sessionStorage');

type Props = {
  name?: string;
  children?: React.ReactNode;
};

const ClearReloadFlushFlag: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  shouldFlushDataStorage.set(false);
  return <>{children}</>;
};

const ErrorBoundary: React.FC<Props> = ({ name = 'unnamed', children }) => (
  <Sentry.ErrorBoundary
    fallback={<SomethingWentWrong />}
    beforeCapture={scope => {
      scope.setTag('source', 'react_error_boundary');
      scope.setTag('error_boundary', name);
    }}
    onError={error => {
      if (isChunkLoadError(error)) {
        fetchErrorHandler(error);
      }
    }}
  >
    <ClearReloadFlushFlag>{children}</ClearReloadFlushFlag>
  </Sentry.ErrorBoundary>
);

export default ErrorBoundary;
